// src/components/admin/admin/AboutManagement.jsx
import React, { useState, useEffect } from "react";
import api from "../../../services/httpService";
import "./AboutSections.css";

/* ================= SECTION CONFIG ================= */
const SECTION_CONFIG = [
  { type: "hero", label: "Hero Section", hasImage: true, hasTitle: true, hasDescription: true },
  { type: "about-us", label: "About Us", hasImage:  true, hasTitle: true, hasDescription: true },
  { type: "why-choose-us", label: "Why Choose Us", hasImage:  false, hasTitle: true, hasDescription: true },
  { type: "content1", label: "Content Section 1", hasImage:  false, hasTitle: true, hasDescription: true },
  { type: "content2", label: "Content Section 2", hasImage:  false, hasTitle: true, hasDescription: true },
  { type: "content3", label: "Content Section 3", hasImage:  false, hasTitle: true, hasDescription: true },
];

const AboutManagement = () => {
  const [sections, setSections] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [message, setMessage] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSections();
  }, []);

  const loadSections = async () => {
    setLoading(true);
    const res = await api.get("/sentinix/aboutsections");
    setSections(res.data.data || []);
    setLoading(false);
  };

  const handleChange = (id, key, value) => {
    setSections((prev) =>
      prev.map((s) => (s.id === id ? { ...s, [key]: value } : s))
    );
  };

  const handleImage = (id, e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedImage({ id, file, preview: reader.result });
    };
    reader.readAsDataURL(file);
  };

  const handleSave = async (section) => {
  const formData = new FormData();
  formData.append("title", section.title || "");
  formData.append("description", section.description || "");

  if (selectedImage?.id === section.id) {
    formData.append("imageKey", selectedImage.file);
  } else if (section.imageKey && typeof section.imageKey === "string") {
    formData.append("imageKey", section.imageKey);
  }

  await api.put(
    `/sentinix/aboutsections/${section.id}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } } 
  );

  setMessage("Updated successfully");
  setEditingId(null);
  setSelectedImage(null);
  loadSections();
  setTimeout(() => setMessage(""), 3000);
};

  if (loading) {
    return (
      <div className="loading-box">
        <div className="spinner" />
        Loading sections...
      </div>
    );
  }

  return (
    <div className="about-mgmt-container">
      <div className="about-page-header">
        <h1>About Page Management</h1>
        <p>Manage hero, about, and content sections</p>
      </div>

      {message && <div className="about-message success">{message}</div>}

      <div className="about-sections-grid">
        {SECTION_CONFIG.map((cfg) => {
          const section = sections.find((s) => s.sectionType === cfg.type);
          if (!section) return null;

          const editing = editingId === section.id;
          const image =
            selectedImage?.id === section.id
              ? selectedImage.preview
              : section.imageKey;

          return (
            <div
              key={cfg.type}
              className={`about-section-card ${
                cfg.type === "hero" ? "hero-card" : ""
              }`}
            >
              {/* HEADER */}
              <div className="about-section-card-header">
                <div className="section-label-row">
                  <h3>{cfg.label}</h3>
                  <span className="section-type-badge">{cfg.type}</span>
                </div>
                {!editing && (
                  <button
                    className="btn-edit-about"
                    onClick={() => setEditingId(section.id)}
                  >
                    Edit
                  </button>
                )}
              </div>

              {/* BODY */}
              <div className="about-section-card-body">
                {/* TITLE */}
                <div className="form-group-about">
                  <label>Title</label>
                  {editing ? (
                    <input
                      className="form-input-about"
                      value={section.title || ""}
                      onChange={(e) =>
                        handleChange(section.id, "title", e.target.value)
                      }
                    />
                  ) : (
                    <p className="field-value-about">{section.title}</p>
                  )}
                </div>

                {/* DESCRIPTION */}
                <div className="form-group-about">
                  <label>Description</label>
                  {editing ? (
                    <textarea
                      className="form-textarea-about"
                      rows={4}
                      value={section.description || ""}
                      onChange={(e) =>
                        handleChange(section.id, "description", e.target.value)
                      }
                    />
                  ) : (
                    <p className="field-value-about">{section.description}</p>
                  )}
                </div>

                {/* IMAGE */}
                {cfg.hasImage && (
                  <div className="form-group-about">
                    <label>Image</label>
                    {image ? (
                      <div className="image-preview-about">
                        <img src={image} alt="preview" />
                      </div>
                    ) : (
                      <p className="field-value-about no-image">No image</p>
                    )}

                    {editing && (
                      <div className="image-upload-about">
                        <input
                          type="file"
                          className="file-input-about"
                          onChange={(e) => handleImage(section.id, e)}
                        />
                        <p className="image-note">Recommended size: 1200×600</p>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* FOOTER */}
              {editing && (
                <div className="about-section-card-footer">
                  <button
                    className="btn-save-about"
                    onClick={() => handleSave(section)}
                  >
                    Save
                  </button>
                  <button
                    className="btn-cancel-about"
                    onClick={() => setEditingId(null)}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AboutManagement;
